import Head from "next/head";
import { make as SetWrappedPage } from "../../../src/set-wrapped13/SetWrapped13Page.bs";

export default function Wrapped() {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=640px, maximum-scale=1" />
        <title>Set 13 Into The Arcane Wrapped - Teamfight Tactics</title>
      </Head>
      <SetWrappedPage />
    </>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
